export const manageVoucherLoginByLang = {
  es: '/gestionar-bono/login/',
  pt: '/pt/gerir-voucher/login/',
}

export const manageVoucherFormByLang = {
  es: '/gestionar-bono/',
  pt: '/pt/gerir-voucher/',
}

export const redeemGetAwayByLang = {
  es: '/canjear-escapada/',
  pt: '/pt/resgatar-escapadinha/',
}

export const contactByLang = {
  es: '/formulario-de-contacto/',
  pt: '/pt/formulario-de-contacto/',
}

export const legalNoticeByLang = {
  es: '/aviso-legal/',
  pt: '/pt/aviso-legal/',
}

export function isManageVoucherLoginURL(url: string): boolean {
  for (const [_, value] of Object.entries(manageVoucherLoginByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isManageVoucherFormURL(url: string) {
  for (const [_, value] of Object.entries(manageVoucherFormByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isRedeemGetAwayURL(url: string) {
  for (const [_, value] of Object.entries(redeemGetAwayByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isContactURL(url: string) {
  for (const [_, value] of Object.entries(contactByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isLegalNoticeURL(url: string) {
  for (const [_, value] of Object.entries(legalNoticeByLang)) {
    if (url === value) {
      return true
    }
  }

  return false
}

export function isStaticURL(url: string): boolean {
  if (isManageVoucherLoginURL(url)) {
    return true
  }

  if (isManageVoucherFormURL(url)) {
    return true
  }

  if (isRedeemGetAwayURL(url)) {
    return true
  }

  if (isContactURL(url)) {
    return true
  }

  if (isLegalNoticeURL(url)) {
    return true
  }

  return false
}
